export enum CalendarEventBlock {
  Root = 'CalendarEvent',
}
